import { render } from "./Artboard.vue?vue&type=template&id=c507122a"
import script from "./Artboard.vue?vue&type=script&lang=js"
export * from "./Artboard.vue?vue&type=script&lang=js"

import "./Artboard.vue?vue&type=style&index=0&id=c507122a&lang=css"

import exportComponent from "/Users/patrikhubner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__